module.exports = __webpack_public_path__ + "img/icon-tick-circle.ad926fc6.svg";